import React, { useEffect, useState } from 'react';
import api from '../api';

const PesertaUploadPembayaran = () => {
    const [events, setEvents] = useState([]);
    const [pembayaranList, setPembayaranList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const apiUrl = process.env.REACT_APP_API_ENDPOINT;
    const [formData, setFormData] = useState({
        event: '',
        norek: '',
        bank: '',
        atasNama: '',
        tglPembayaran: '',
        bukti: null
    });
    const [errors, setErrors] = useState({});
    const [preview, setPreview] = useState(null);
    const [previewEdit, setPreviewEdit] = useState(null);
    const [searchRef, setSearchRef] = useState('');

    // Pagination state
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(0);

    // Fetch events
    useEffect(() => {
        api.get(`${apiUrl}/api/peserta/my-events`)
            .then(res => setEvents(res.data))
            .catch(err => console.error(err));
    }, [apiUrl]);

    // Fetch pembayaran list with pagination
    useEffect(() => {
        const url = searchRef
            ? `${apiUrl}/api/peserta/pembayaran-search?page=${page}&size=${size}&nomorReferensi=${encodeURIComponent(searchRef)}`
            : `${apiUrl}/api/peserta/pembayaran-page?page=${page}&size=${size}`;
        api.get(url)
            .then(res => {
                setPembayaranList(res.data.content);
                setTotalPages(res.data.totalPages);
                setTotalElements(res.data.totalElements);
            })
            .catch(err => console.error(err));
    }, [apiUrl, showModal, page, size, searchRef]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
            setFormData(prev => ({ ...prev, bukti: file }));
            setPreview(URL.createObjectURL(file));
            setErrors(prev => ({ ...prev, bukti: false }));
        } else {
            setErrors(prev => ({ ...prev, bukti: true }));
            setFormData(prev => ({ ...prev, bukti: null }));
            setPreview(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!formData.event) newErrors.event = true;
        if (!formData.norek) newErrors.norek = true;
        if (!formData.bank) newErrors.bank = true;
        if (!formData.atasNama) newErrors.atasNama = true;
        if (!formData.tglPembayaran) newErrors.tglPembayaran = true;
        if (!formData.bukti) newErrors.bukti = true;
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const data = new FormData();
        data.append('eventId', formData.event);
        data.append('norek', formData.norek);
        data.append('bank', formData.bank);
        data.append('atasNama', formData.atasNama);
        data.append('tglPembayaran', formData.tglPembayaran);
        data.append('nomorReferensi', formData.nomorReferensi); // tambahkan ini
        data.append('bukti', formData.bukti);

        try {
            await api.post(`${apiUrl}/api/peserta/upload-pembayaran`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            alert('Upload berhasil!');
            setFormData({
                event: '',
                norek: '',
                bank: '',
                atasNama: '',
                tglPembayaran: '',
                bukti: null
            });
            setPreview(null);
            setShowModal(false);
        } catch (err) {
            alert('Upload gagal!');
            console.error(err);
        }
    };

    // Dropdown page size
    const setPageListItems = (event) => {
        const value = parseInt(event.target.getAttribute('data-value'), 10);
        setSize(value);
        setPage(0);
    };

    // Handle file change for edit
    const handleEditFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
            setEditData(prev => ({ ...prev, bukti: file }));
            setPreviewEdit(URL.createObjectURL(file));
        } else {
            setEditData(prev => ({ ...prev, bukti: null }));
            setPreviewEdit(null);
        }
    };

    // Handle edit submit
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('eventId', editData.event.id || editData.event); // tergantung struktur
        data.append('norek', editData.norek);
        data.append('bank', editData.bank);
        data.append('atasNama', editData.atasNama);
        data.append('tglPembayaran', editData.tglPembayaran);
        data.append('nomorReferensi', editData.nomorReferensi);
        if (editData.bukti instanceof File) {
            data.append('bukti', editData.bukti);
        }
        try {
            await api.put(
                `${apiUrl}/api/peserta/edit-pembayaran/${editData.id}`,
                data,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            setShowEditModal(false);
            setEditData(null);
            setPreviewEdit(null);
            // Refresh data
            api.get(`${apiUrl}/api/peserta/pembayaran-page?page=${page}&size=${size}`)
                .then(res => {
                    setPembayaranList(res.data.content);
                    setTotalPages(res.data.totalPages);
                    setTotalElements(res.data.totalElements);
                });
        } catch (err) {
            alert('Edit gagal!');
        }
    };

    return (
        <>

            <div className="page-wrapper">
                {/* Page header */}
                <div className="page-header d-print-none">
                    <div className="container-xl">
                        <div className="row g-2 align-items-center">
                            <div className="col">
                                <h2 className="page-title">
                                    Upload Bukti Pembayaran
                                    <span className="text-muted"> - Peserta</span>
                                </h2>
                            </div>
                            {/* Page title actions */}
                            <div className="col-auto ms-auto d-print-none">
                                <div className="btn-list">
                                    <a
                                        href="#"
                                        className="btn btn-primary d-none d-sm-inline-block"
                                        onClick={e => { e.preventDefault(); setShowModal(true); }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round" className="icon icon-2">
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                        </svg>
                                        Upload Bukti Pembayaran
                                    </a>
                                    <a
                                        href="#"
                                        className="btn btn-primary d-sm-none btn-icon"
                                        onClick={e => { e.preventDefault(); setShowModal(true); }}
                                        aria-label="Create new report"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round" className="icon icon-2">
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Page body */}
                <div className="page-body">
                    <div className="container-xl">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center w-full">
                                        <div className="col">
                                        </div>
                                        <div className="col-md-auto col-sm-12">
                                            <div className="ms-auto d-flex flex-wrap btn-list">
                                                <div className="input-group input-group-flat w-auto">
                                                    <span className="input-group-text">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                                            className="icon icon-1">
                                                            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                                                            <path d="M21 21l-6 -6"></path>
                                                        </svg>
                                                    </span>
                                                    <input
                                                        id="advanced-table-search"
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        placeholder="Cari Nomor Referensi"
                                                        value={searchRef}
                                                        onChange={e => {
                                                            setSearchRef(e.target.value);
                                                            setPage(0);
                                                        }}
                                                    />
                                                    <span className="input-group-text">
                                                    </span>
                                                </div>
                                                <div className="dropdown">
                                                    <a href="#" className="btn dropdown-toggle"
                                                        data-bs-toggle="dropdown">Actions</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" href="#">Edit</a>
                                                        <a className="dropdown-item" href="#">Delete</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="table-default" className="table-responsive">
                                    <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Event</th>
                                                <th>Nomor Rekening</th>
                                                <th>Nama Bank</th>
                                                <th>Atas Nama</th>
                                                <th>Tanggal Pembayaran</th>
                                                <th>Nomor Referensi</th>
                                                <th>Bukti</th>
                                                <th>Status</th>
                                                <th>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pembayaranList.length === 0 ? (
                                                <tr>
                                                    <td colSpan={10} className="text-center">Data tidak ditemukan</td>
                                                </tr>
                                            ) : pembayaranList.map((item, idx) => (
                                                <tr key={item.id || idx}>
                                                    <td>{page * size + idx + 1}</td>
                                                    <td>{item.event?.eventCode} - {item.event?.title}</td>
                                                    <td>{item.norek}</td>
                                                    <td>{item.bank}</td>
                                                    <td>{item.atasNama}</td>
                                                    <td>{item.tglPembayaran}</td>
                                                    <td>{item.nomorReferensi}</td>
                                                    <td>
                                                        {item.buktiPath && (
                                                            <a
                                                                href={`${apiUrl}/api/public/displayimage/${item.buktiPath}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Lihat
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>
                                                      <span className={`badge bg-${
                                                        item.status === 'APPROVED'
                                                          ? 'green'
                                                          : item.status === 'REJECTED'
                                                          ? 'red'
                                                          : item.status === 'VERIFIED'
                                                          ? 'blue'
                                                          : 'yellow'
                                                      }`}>
                                                        {item.status}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <button
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() => {
                                                          setEditData(item);
                                                          setShowEditModal(true);
                                                          setPreviewEdit(item.buktiPath ? `${apiUrl}/api/public/displayimage/${item.buktiPath}` : null);
                                                        }}
                                                        disabled={item.status === 'VERIFIED'}
                                                      >
                                                        Edit
                                                      </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer d-flex align-items-center">
                                    <div className="dropdown">
                                        <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                                            <span id="page-count" className="me-1">{size}</span>
                                            <span>records</span>
                                        </a>
                                        <div className="dropdown-menu">
                                            {[2, 10, 20, 50, 100].map(val => (
                                                <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>{val} records</a>
                                            ))}
                                        </div>
                                    </div>
                                    <ul className="pagination m-0 ms-auto">
                                        <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                                            <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                                                onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                                    className="icon icon-1">
                                                    <path d="M15 6l-6 6l6 6" />
                                                </svg>
                                                prev
                                            </a>
                                        </li>
                                        {[...Array(totalPages)].map((_, idx) => (
                                            <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                                                <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                                            </li>
                                        ))}
                                        <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                                            <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                                                onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                                                next
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                                    className="icon icon-1">
                                                    <path d="M9 6l6 6l-6 6" />
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            {/* Modal */}
            {showModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit} encType="multipart/form-data">
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload Bukti Pembayaran</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Event</label>
                                        <select
                                            className={`form-select ${errors.event ? 'is-invalid' : ''}`}
                                            name="event"
                                            value={formData.event}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Pilih Event</option>
                                            {events.map(event => (
                                                <option key={event.id} value={event.id}>
                                                    {event.eventCode} - {event.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nomor Rekening Pengirim</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.norek ? 'is-invalid' : ''}`}
                                            name="norek"
                                            value={formData.norek}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nama Bank Pengirim</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.bank ? 'is-invalid' : ''}`}
                                            name="bank"
                                            value={formData.bank}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Atas Nama Pengirim</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.atasNama ? 'is-invalid' : ''}`}
                                            name="atasNama"
                                            value={formData.atasNama}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Tanggal Pembayaran</label>
                                        <input
                                            type="date"
                                            className={`form-control ${errors.tglPembayaran ? 'is-invalid' : ''}`}
                                            name="tglPembayaran"
                                            value={formData.tglPembayaran}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Bukti Pembayaran (.jpg/.png)</label>
                                        <input
                                            type="file"
                                            className={`form-control ${errors.bukti ? 'is-invalid' : ''}`}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={handleFileChange}
                                            required
                                        />
                                        {preview && (
                                            <div className="mt-2">
                                                <img src={preview} alt="Preview" style={{ maxWidth: 200 }} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nomor Referensi</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.nomorReferensi ? 'is-invalid' : ''}`}
                                            name="nomorReferensi"
                                            value={formData.nomorReferensi || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">Upload</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Edit */}
            {showEditModal && editData && (
                <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <form onSubmit={handleEditSubmit} encType="multipart/form-data">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Pembayaran</h5>
                                    <button type="button" className="btn-close" onClick={() => { setShowEditModal(false); setEditData(null); setPreviewEdit(null); }}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Event</label>
                                        <select
                                            className="form-select"
                                            value={editData.event?.id || editData.event}
                                            onChange={e => setEditData(prev => ({ ...prev, event: { ...prev.event, id: e.target.value } }))}
                                            required
                                        >
                                            <option value="">Pilih Event</option>
                                            {events.map(event => (
                                                <option key={event.id} value={event.id}>
                                                    {event.eventCode} - {event.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nomor Rekening Pengirim</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="norek"
                                            value={editData.norek}
                                            onChange={e => setEditData(prev => ({ ...prev, norek: e.target.value }))}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nama Bank Pengirim</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="bank"
                                            value={editData.bank}
                                            onChange={e => setEditData(prev => ({ ...prev, bank: e.target.value }))}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Atas Nama Pengirim</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="atasNama"
                                            value={editData.atasNama}
                                            onChange={e => setEditData(prev => ({ ...prev, atasNama: e.target.value }))}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Tanggal Pembayaran</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="tglPembayaran"
                                            value={editData.tglPembayaran}
                                            onChange={e => setEditData(prev => ({ ...prev, tglPembayaran: e.target.value }))}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nomor Referensi</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="nomorReferensi"
                                            value={editData.nomorReferensi}
                                            onChange={e => setEditData(prev => ({ ...prev, nomorReferensi: e.target.value }))}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Bukti Pembayaran (.jpg/.png)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".jpg,.jpeg,.png"
                                            onChange={handleEditFileChange}
                                        />
                                        {/* Preview gambar lama atau baru */}
                                        {previewEdit && (
                                            <div className="mt-2">
                                                <img src={previewEdit} alt="Preview" style={{ maxWidth: 200 }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => { setShowEditModal(false); setEditData(null); setPreviewEdit(null); }}>
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

        </>

    );
};

export default PesertaUploadPembayaran;